import { atom } from "recoil";
import { PlanKey } from "../components/task/payment/planTypes";

export interface UserType {
  accessToken?: string;
  // "jwt": JWT 세션(코치 웹·유저 PC 웹). 토큰은 메모리(api/coachAuth)에만 있고 여기엔 표식만 남는다.
  authMode?: "jwt";
  // "pcweb": 유저 PC 웹(QR) 세션 — 전용 리프레시 쿠키(_distancing_pc)를 쓴다.
  // "coach": 코치 화면 세션 — 전용 리프레시 쿠키(_distancing_coach)를 쓴다. 표식 없는 예전 코치 프로필은 undefined.
  sessionKind?: "pcweb" | "coach";
  role?: string;
  nickname?: string;
  authenticateType?: string;
  isNicknameChangeRequired?: boolean;
  email?: string;
  userId?: number;
  programStartedAt?: string;
  hasPraised?: boolean;
  surveySeq?: number;
  dayNumber?: number;
  subscription?: {
    hasStarted: boolean;
    isSubscribing: boolean;
    expiryDaysLeft?: number;
    latestPaidAt?: string;
    expirationAt?: string;
    canceledAt?: string; // 인앱결제만
    renewedAt?: string; // 인앱결제만
    bonusDays?: number;
    isFirstSubscription: boolean;
    hasBeenRefunded: boolean;
    hasBeenPlanUpgraded: boolean;
    // 구독 일시중지 상태 (서버는 전용 상태값 없이 SUBSCRIBING_EXPIRED 로 저장)
    isPaused?: boolean;
  };
  isMandatoryTaskForRefundDone?: boolean;
  isEarlyAccess?: boolean;
  assignedCoachName?: string;
  isOnboardingRequired?: boolean;
  isCommitmentRequired?: boolean;
  onboardingType?: string;
  benefit?: string;
  appId?: string;
  pricingModel?: string;
  programType?: string;
  lastTaskUpdatedAt?: string;
  todayTaskUpdateCount?: number;
  weeklyTaskUpdateCount?: number;
  isCarePass?: boolean;
  trackId?: string;
  plan?: PlanKey;
  paymentPageType?: string;
  refundPolicyType?: string;
  segmentType?: string;
  isInsider?: boolean;
  isStoreReviewer?: boolean;
  isSimulated?: boolean; // 교육용 모의 내담자 계정
  isWebFunnelRegister?: boolean;
  isDemographicRequired?: boolean;
  promotion?: string;
  referralCode?: string;
  referralName?: string;
  referralDisplayName?: string;
  // 레퍼럴 코드 유형 (affiliate=제휴/discount=단순할인, 레퍼럴로 진입한 경우만)
  referralCodeType?: "affiliate" | "discount";
}

export const userAtom = atom<UserType | undefined>({
  key: "user",
  default: undefined,
  effects: [
    ({ setSelf, onSet }) => {
      // 깨진 값("undefined", 잘못된 JSON)이 들어 있으면 앱이 부팅에서 죽으므로 버린다.
      const savedData = localStorage.getItem("user");
      if (savedData) {
        try {
          const parsed = JSON.parse(savedData);
          if (parsed && typeof parsed === "object") setSelf(parsed);
          else localStorage.removeItem("user");
        } catch {
          localStorage.removeItem("user");
        }
      }

      // atom이 변화가 감지될 때 작동, Storage에 데이터 저장
      // setSelf에 의해서는 작동하지 않음. undefined 는 JSON.stringify 가 문자열을 못 만들어 "undefined" 가 저장되므로 삭제로 처리한다.
      onSet((newValue, _, isReset) => {
        isReset || newValue == null
          ? localStorage.removeItem("user")
          : localStorage.setItem("user", JSON.stringify(newValue));
      });
    },
  ],
});
